import { render, staticRenderFns } from "./ApptPriorities.vue?vue&type=template&id=4ec7f574&"
import script from "./ApptPriorities.vue?vue&type=script&lang=ts&"
export * from "./ApptPriorities.vue?vue&type=script&lang=ts&"
import style0 from "./ApptPriorities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports